import { generateTheme } from '../styles/theme';
import { dateTimeFormat } from '../i18n/dateTimeFormat';
import { RouterLink } from '../components/common/link/RouterLink';
import { useNavigate } from '../navigation/useNavigate';
import { ICustomConfig, RouterLinkComponentType } from '../ui';
import { AirportCodes } from '../types/airports';

export function getUiConfig(currentAirport?: AirportCodes): ICustomConfig {
	const theme = generateTheme(currentAirport);

	return {
		theme,
		dateTimeFormat,
		RouterLinkComponent: RouterLink as RouterLinkComponentType,
		useNavigate,
	};
}
